export default "__VITE_ASSET__DVvBMduq__"